import { IconBolt, IconClock, IconGift } from "@tabler/icons-react";
import { Trans } from "@lingui/macro";

import { cx } from "../common/cx";
import { useCountdown } from "./useCountdown";
import { urgencyTier } from "./urgency";
import styles from "./UrgentBanner.module.css";

export interface UrgentBannerProps {
  deadlineMs: number;
  durationMs: number;
  bonusPct: number;
  onExpire?: () => void;
}

export function UrgentBanner({
  deadlineMs,
  durationMs,
  bonusPct,
  onExpire,
}: UrgentBannerProps): JSX.Element {
  const { label, remainingMs } = useCountdown(deadlineMs, onExpire);
  const tier = urgencyTier(remainingMs, durationMs);
  const tierClass = { normal: styles.tierNormal, warning: styles.tierWarning, critical: styles.tierCritical }[tier];
  const bonusPctDisplay = Math.round(bonusPct * 100);

  return (
    <div className={cx(styles.banner, tierClass)}>
      <span className={styles.badge}>
        <IconBolt size={15} aria-hidden="true" /> <Trans>Срочная миссия</Trans>
      </span>
      <span className={cx(styles.timer, "mono")}>
        <IconClock size={16} aria-hidden="true" /> {label}
      </span>
      <span className={styles.bonus}>
        <IconGift size={15} aria-hidden="true" /> <Trans>+{bonusPctDisplay}% награды</Trans>
      </span>
    </div>
  );
}
